// extracted by mini-css-extract-plugin
export default {"mapPanel":"MapAuxiliary_mapPanel__DZoEb","map":"MapAuxiliary_map__pDMwx"};